<template>
  <ul :style="{ paddingBottom: isIphoneX ? '32px' : '12px' }">
    <TabItem
      :icon-img="homeIcon"
      :icon-img-active="homeIconActive"
      name="首页"
      route-name="home"
    />
    <TabItem
      :icon-img="videoIcon"
      :icon-img-active="videoIconActive"
      name="视频"
      route-name="video"
    />
    <TabItem
      :icon-img="vipIcon"
      :icon-img-active="vipIconActive"
      name="VIP"
      route-name="vip"
    />
    <TabItem
      :icon-img="messageIcon"
      :icon-img-active="messageIconActive"
      name="消息"
      route-name="message"
    />
    <TabItem
      :icon-img="personalIcon"
      :icon-img-active="personalIconActive"
      name="我的"
      route-name="personal"
    />
  </ul>
</template>

<script>
import TabItem from "./TabItem";
import homeIcon from "@/assets/icons/tabbar/home@2x.png";
import homeIconActive from "@/assets/icons/tabbar/home_active@2x.png";
import videoIcon from "@/assets/icons/tabbar/video@2x.png";
import videoIconActive from "@/assets/icons/tabbar/video_active@2x.png";
import vipIcon from "@/assets/icons/tabbar/vip@2x.png";
import vipIconActive from "@/assets/icons/tabbar/vip_active@2x.png";
import messageIcon from "@/assets/icons/tabbar/message@2x.png";
import messageIconActive from "@/assets/icons/tabbar/message_active@2x.png";
import personalIcon from "@/assets/icons/tabbar/personal@2x.png";
import personalIconActive from "@/assets/icons/tabbar/personal_active@2x.png";
import { isIphoneX } from "@/utils/isIphoneX";
export default {
  components: {
    TabItem
  },
  data() {
    return {
      homeIcon,
      videoIcon,
      vipIcon,
      messageIcon,
      personalIcon,
      homeIconActive,
      videoIconActive,
      vipIconActive,
      messageIconActive,
      personalIconActive,
      isIphoneX: isIphoneX()
    };
  }
};
</script>

<style lang="scss" scoped>
ul {
  border-top: 1px solid #d8d8d8;
  position: fixed;
  bottom: 0;
  margin: 0;
  padding: 3px 0 0 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 1px 0 0 rgba(216, 216, 216, 1);
  z-index: 100;
}
</style>
